import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import TableLayout from "../../../components/TableLayout";
import TableActions from "../../../components/Common/TableActions";
import { ROOMTYPE, ROOMTYPEDELETE, ROOMTYPELIST } from "../../../services/ApiCalls";
import dataHandler from "../../../hooks/dataHandler";
import moment from "moment";
import Filter from "../../../components/Common/Filter";
import {
  activeInactiveOptions,
  AdminStatusOptionSubscription,
  defaultDeleteModelState,
} from "../../../utilities/const";
import { Link } from "react-router-dom";

import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import CustomPagination from "../../../components/Common/CustomPagination";
import { useTranslation } from "react-i18next";

const RoomType = () => {
  const roomTypeFilter=[
    {
    label: "All",
    value: "",
  },
  {
    label: "Active",
    value: "Active",
  },
  {
    label: "In Active",
    value: "Inactive",
  },
  ]
  const { t } = useTranslation();
  const {
    setBody,

    body,
    data,
    loader,
    deleteModel,
    setDeleteModel,
    setCommisionModel,
    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
  } = dataHandler({
    api: ROOMTYPELIST,
  });

  const column = [
    {
      head: t("roomType.columns.srNo"),
      accessor: "#",
      component: (item, key) => {
        return <>{key < 9 ? `0${key + 1}` : key + 1}</>;
      },
    },

    {
      head: t("roomType.columns.hotelName"),
      accessor: "hotelName",
      component: (item) => <>{item?.hotelId?.hotelName}</>,
    },

    {
      head: t("roomType.columns.roomType"),
      accessor: "roomType",
      component: (item) => <>{item?.roomType?.name}</>,

    },
    {
      head: t("roomType.columns.totalRoom"),
      accessor: "totalRoom",
    },
    {
      head: t("roomType.columns.availRoom"),
      accessor: "availableRoom",
    },

    {
      head: t("roomType.columns.description"),
      accessor: "description",
      component: (item, key, arr) => (
        <div style={{maxWidth:"150px"}} className="text-truncate">{item?.description ? item?.description : "--"}</div>
      ),
    },

    {
      head: t("roomType.columns.status"),
      accessor: "status",
      component: (item, key, arr) => (
        <span className="">{item?.status ? item?.status : "--"}</span>
      ),
    },
    {
      head: t("roomType.columns.action"),
      accessor: "Action",
      component: (item) => {
        console.log(item, "item");
        return (
          <TableActions
            editUrl={`/roomtype/edit/${item._id}`}
            viewLink={`/roomtype/detail/${item._id}`}
          />
        );
      },
    },
  ];

  return (
    <>
      
      <section className="promocode py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                {t("roomType.title")}
              </h4>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <Filter
                    body={body}
                    setBody={setBody}
                    searchHandler={searchHandler}
                    statusFilterOptionArr={roomTypeFilter}
                  />
                </div>
                <div className="right">
                  <Link
                    to="/roomtype/add"
                    className="d-flex btn btn-primary align-items-center justify-content-center fw-sbold commonBtn "
                    style={{ height: 40, minWidth: 100, fontSize: 12 }}
                  >
                    {t("roomType.addRoomType")}
                  </Link>
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <TableLayout column={column} data={data} loader={loader} />
              <CustomPagination
                total={total}
                pageChangeHandler={paginationHandler}
                body={body}
                setBody={setBody}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default RoomType;
